import Constants from '@/constants';

export const COUNTRIES: { id: string; label?: string }[] = [
  Constants.SUPPORTED_COUNTRIES.US,
  Constants.SUPPORTED_COUNTRIES.PR,
  Constants.SUPPORTED_COUNTRIES.CA,
  Constants.SUPPORTED_COUNTRIES.GB,
  Constants.SUPPORTED_COUNTRIES.SG,
];

/**
 * @param code in [US, GB, PR, CA, SG]
 * @returns label: US, UK, PR, CA, SG
 */
export const getCountryLabel = (code: string): string => {
  if (code === Constants.SUPPORTED_COUNTRIES.GB.id) {
    return Constants.SUPPORTED_COUNTRIES.GB.label;
  }
  return code;
};
